import { useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useVerticalUI } from '@/lib/verticalUI'
import { buildCatalogNavTabs } from './catalogNavTabs.items'

interface CatalogNavTabsProps {
  className?: string
}

export default function CatalogNavTabs({ className }: CatalogNavTabsProps) {
  const location = useLocation()
  const { profile } = useVerticalUI()

  const tabs = useMemo(
    () => buildCatalogNavTabs(profile.terminology.itemsPluralName),
    [profile]
  )

  return (
    <div
      data-testid="catalog-nav-tabs"
      className={`border-b border-slate-200 bg-white/90 backdrop-blur px-3 py-2 sm:px-4 sm:rounded-2xl sm:border sm:shadow-sm mb-5 ${className || ''}`}
    >
      <div className="flex items-center justify-between gap-3">
        <nav
          className="flex space-x-1.5 sm:space-x-2 overflow-x-auto py-0.5 scrollbar-none w-full"
          aria-label="Submenú de Catálogo"
        >
          {tabs.map((tab) => {
            const Icon = tab.icon
            const isActive =
              location.pathname === tab.path ||
              (tab.path !== '/app/catalog' && location.pathname.startsWith(`${tab.path}/`))

            return (
              <Link
                key={tab.path}
                to={tab.path}
                className={[
                  'flex items-center gap-2 whitespace-nowrap rounded-xl px-3 py-2 text-xs sm:text-sm font-semibold transition-all',
                  isActive
                    ? 'bg-[#075f55] text-white shadow-sm'
                    : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900',
                ].join(' ')}
                title={tab.description}
              >
                <Icon className={`h-4 w-4 ${isActive ? 'text-white' : 'text-slate-500'}`} />
                <span>{tab.name}</span>
              </Link>
            )
          })}
        </nav>
      </div>
    </div>
  )
}
